module.exports = __webpack_public_path__ + "media/images/desktop-app-c9462d26015c9136ed76d609fd3d2cb9.png";